/* @generated */
const defineStrictThemeOverrides = (overrides) => {
  return overrides;
};
export {
  defineStrictThemeOverrides
};
